import { ArrowLeftIcon } from '@heroicons/react/solid';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const { tableau } = window;

const DashboardPage = () => {
    document.title = 'Dashboard';

    const location = useLocation();
    const { vizURL, title } = location.state;
    // console.log(vizURL);
    // eslint-disable-next-line no-unused-vars
    const [viz, setViz] = useState(null);

    const initViz = () => {
        const containerDiv = document.getElementById('container');
        const options = {
            hideTabs: true,
            hideToolbar: true,
            onFirstInteractive() {
                console.log('This viz is interactive.');
            },
        };
        setViz(new tableau.Viz(containerDiv, vizURL, options));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(initViz, []);
    return (
        <div className="mt-4 flex flex-col items-center">
            <Link
                to="/"
                className="my-3 flex items-center justify-center text-gray-700 dark:text-gray-200"
            >
                <ArrowLeftIcon className="h-3 w-5" />
                <span>Back</span>
            </Link>
            <div id="container" />
            <div className="my-4">
                <h4 className="text-4xl font-semibold dark:text-gray-200">{title}</h4>
            </div>
        </div>
    );
};

export default DashboardPage;
